import { render } from "./MTestsuits.vue?vue&type=template&id=4d1622ef"
import script from "./MTestsuits.vue?vue&type=script&lang=js"
export * from "./MTestsuits.vue?vue&type=script&lang=js"

import "./MTestsuits.vue?vue&type=style&index=0&id=4d1622ef&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__